import { render, staticRenderFns } from "./RedesSociaisIcon.vue?vue&type=template&id=f78f039c&"
import script from "./RedesSociaisIcon.vue?vue&type=script&lang=ts&"
export * from "./RedesSociaisIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports